import React, { Component } from 'react';
import Banner from '../../components/common/Banner';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';
import ModalImage from "react-modal-image";
import { doc, getDoc } from 'firebase/firestore';
import { firestore } from '../../Config/FbConfig';
import ReactPaginate from 'react-paginate';

export default class Gallery extends Component {

  state = {
    Datas: [],
    itemOffset: 0,
  }

  async componentDidMount() {
    //For Teaching
    const docRef = doc(firestore, "Library", "LibraryGallery");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      var Data = []
      Object.entries(docSnap.data()).forEach(([key, value]) => {
        Data.push(Object.assign(
          {
            Id: key,
            Priority: value.Priority != undefined ? value.Priority : "999",
            Image: value.Image,
            Header: value.Description,
          }))
      });

      Data.length === 0 ? this.setState({ Datas: "NO_999" }) : this.setState({ Datas: Data.sort(function (a, b) { return a.Priority - b.Priority; }) })

    }

    else { this.setState({ Datas: "NO_999" }) }
  }

  //Handel changes
  handlePageClick = (event) => {
    const itemsPerPage = 9;
    const newOffset = (event.selected * itemsPerPage) % this.state.Datas.length;
    this.setState({ itemOffset: newOffset });

    //Page Up
    window.scrollTo(0, 0)
  };

  render() {

    const itemsPerPage = 9;
    const { itemOffset } = this.state;
    const endOffset = itemOffset + itemsPerPage;
    const currentItems = this.state.Datas.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(this.state.Datas.length / itemsPerPage);

    return (
      <div>

        {/* Header */}
        <Header />

        {/* Banner */}
        <Banner title="Library Gallery" image="banner/library-2.jpg" />

        {/* Dynamic Data */}
        <div className="container">
          <div className="row paddingtop-2">
            {
              currentItems && currentItems.map((data) => (
                <div className="col-lg-4 paddingtop-2" key={data.Id}>
                  <div className="gallery-box">
                    <ModalImage className="swaraimage1" small={data.Image} large={data.Image} alt="" />
                  </div>
                  <br />
                  <p style={{ color: "black", textAlign: "center" }}>{data.Header}</p>
                </div>
              ))
            }
          </div>
          <br />
        </div>

        {/* Pagination Numbers */}
        <ReactPaginate
          breakLabel="..."
          nextLabel="next"
          onPageChange={this.handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="previous"
          renderOnZeroPageCount={null}
          // Adding CSS styling to the pagination component by using the props provided by the react-paginate library
          containerClassName={'pagination'}
          pageLinkClassName={'pageNum'}
          previousLinkClassName={'pageNum'}
          nextLinkClassName={'pageNum'}
          activeLinkClassName={'active'}
        /><br />

        {/* Footer */}
        <Footer />

      </div>
    )
  }
}
